'use client'

import dynamic from 'next/dynamic'
import {stegaClean} from '@sanity/client/stega'
import type {JotulWidgetProps} from '@jotul/jotul-widgets'
import {resolveWidgetMarket} from '@/components/layout/dealerWidgetBrands'
import type {SiteLite} from '@/multisite/types'
import type {SectionChangeoutCampaign} from '@/types/sanity'

const JotulWidget = dynamic<JotulWidgetProps>(
  () => import('@jotul/jotul-widgets').then((mod) => mod.JotulWidget),
  {ssr: false},
)

export function ChangeoutCampaignSection({
  section,
  site,
}: {
  section: SectionChangeoutCampaign
  site?: SiteLite
}) {
  return (
    <JotulWidget
      type="changeOutCampaign"
      market={stegaClean(section.market) || resolveWidgetMarket(site)}
      locale={site?.locale}
      changeoutEndpoint="https://changeout.jotul.com/api/changeout/submit"
    />
  )
}
